// Escapa un valor de texto libre para interpolarlo dentro de un literal de cadena OData ('...').
// OData escapa la comilla simple duplicándola: O'Brien → O''Brien. Sin esto, un valor con
// comilla rompe el filtro o permite inyección OData (ej: x') or true or contains(N,('').
export const escapeODataString = (value?: string | number | null): string => {
  if (value === null || value === undefined) {
    return ''
  }

  return String(value).replaceAll(`'`, `''`)
}
